
const Visualiser = require('../analysis/visualiser')

const d3 = Object.assign({}, require('d3'), require('d3-scale'))
const cloud = require('d3-cloud')

const {get} = require('../request')
const {parse} = require('../html')
const layout = require('./cloud.html')
const wrapperLayout = require('./cloud_wrapper.html')

const {posToName, posColour} = require('../pos')

const NAME = '단어 구름'

const Cloud = class extends Visualiser {
    constructor(analysis, options={}) {
        super(NAME, analysis, {
            width: options.width || 380,
            height: options.height || 256,
            font: options.font || 'sans-serif',
            topN: 10,
            singleChar: true,
        })
        this.width = options.width ? options.width : 380
        this.height = options.height ? options.height : 256
        this.font = options.font ? options.font : 'sans-serif'
    }
    parseInputs(form) {
        const topN = parseInt(form.querySelector('#topn').value)
        const singleChar = form.querySelector('#single-char').checked
        return {topN, singleChar}
    }
    dom() {
        const options = [5, 10, 15, 20, 30, 40, 50]
        const content = parse(layout, {options}).querySelector('#content')
        this.content = content

        const form = content.querySelector('form')
        form.addEventListener('submit', (event) => {
            event.preventDefault()
            Object.assign(this.options, this.parseInputs(form))
            this.update()
            return true
        })

        this.update()
        return content
    }
    update() {
        const clouds = this.content.querySelector('#clouds')

        const {host, port} = this.api
        get(host, port, `/document/${this.document.name}/tokens`, this.config.json()).then(({units}) => {
            const {width, height, font, topN, singleChar} = this.options

            clouds.innerHTML = ''
            Object.values(units).forEach((unit) => {
                const {frequency, name} = unit
                const wrapper = parse(wrapperLayout, {name}).firstChild
                const words = Object.entries(frequency)
                        .map(([t, f]) => ({text: t.split('/')[0], pos: t.split('/')[1], size: f}))
                        .sort((a, b) => b.size - a.size)
                        .filter(word => singleChar || word.text.length > 1)
                        .slice(0, topN)

                const singlePos = words.map(({pos}) => posToName(pos)).filter((a, i, arr) => arr.indexOf(a) === i).length == 1
                const fill = (pos, i) => singlePos ? d3.schemeCategory10[i] : posColour(pos)
                const draw = (words) => d3.select(wrapper.querySelector('#cloud'))
                        .append('svg')
                            .attr('width', width)
                            .attr('height', height)
                        .append('g')
                            .attr('transform', `translate(${width/2}, ${height/2})`)
                        .selectAll('text')
                            .data(words)
                        .enter().append('text')
                            .style('font-size', d => d.size + 'px')
                            .style('font-family', font)
                            .style('fill', (d, i) => fill(d.pos, i))
                            .attr('text-anchor', 'middle')
                            .attr('transform', d => `translate(${d.x}, ${d.y})`)
                            .on('click', (d) => {
                                const {text, pos, color} = d
                                this.ondata({word: text, pos, color})
                            })
                            .text(d => d.text)
                const layout = cloud().size([width, height])
                        .words(words)
                        .padding(5)
                        .rotate(() => Math.random() * 30 - 15)
                        .font(font)
                        .fontSize(d => 10 + Math.log(d.size) * (7 + (7 - words.length / 7)))
                        .on('end', draw)
                layout.start()

                clouds.appendChild(wrapper)
            })
        })
    }
}

module.exports = Cloud
